import styled from 'styled-components';

export const Overlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled('h2')`
  font-size: 23px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  color: #333333;
`;

export const IconButton = styled('button')`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

interface DrawerContentProps {
  open: boolean;
  contentHeight: number;
}

export const Container = styled.div<DrawerContentProps>`
  box-sizing: border-box;
  padding: 10px 16px 16px 16px;
  width: 100%;
  height: fit-content;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;

  z-index: 1000;
  overflow-x: hidden;
  transition: 0.3s ease-in-out 0.5s;
  transition: height 0.1s ease-out;

  transition-delay: 0s;
  box-shadow: 0px -5px 10px 0px #57575733;

  overflow-x: hidden;
  overflow-y: auto;
  max-height: 80vh;
  transition: height 0.5s ease-out;
`;
